import "@/instrument";
import "@/app.css";
import AppRouterProvider from "@/components/app-router-provider";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import "@fontsource-variable/dm-sans/opsz.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { setDefaultOptions } from "date-fns";
import { es } from "date-fns/locale";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import SentryErrorBoundary from "./components/sentry-error-boundary";
import { SentryErrorProvider } from "./store/sentry-error.context";

setDefaultOptions({ locale: es });

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60,
      retry: 1,
      retryDelay: (attempt) =>
        Math.min(attempt > 1 ? 2 ** attempt * 1000 : 1000, 30 * 1000), // applies exponential backoff
    },
  },
});

const mode = import.meta.env.MODE;

if (mode !== "production") {
  console.log(`egs-enduser ${__APP_VERSION__} ${mode}`);
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <SentryErrorProvider>
      <SentryErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <TooltipProvider delayDuration={300}>
            <AppRouterProvider />
          </TooltipProvider>
          <Toaster richColors={true} />
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </SentryErrorBoundary>
    </SentryErrorProvider>
  </StrictMode>,
);
